<div class="parked-cars-wrapper">
  <h2>Parkerade bilar</h2>
  <p class="description">De bilar som har ankommit till parkeringen och ej lämnat.</p>

  <!-- Resource toggle -->
  <div class="resource-and-total-wrapper">
    @if (resources.length) {
      <mat-button-toggle-group #group="matButtonToggleGroup"
        value="{{resources[0].resourceId}}" (change)="changeResourceType(group.value)">
        @for (resource of resources; track resource) {
          <mat-button-toggle value="{{resource.resourceId}}"
          name="resource">{{resource.label}}</mat-button-toggle>
        }
      </mat-button-toggle-group>
    }

    <div class="total-parked-wrapper" title="Totalt antal bilar ({{activeResourceName()}})">
      <mat-icon>directions_car</mat-icon>
      <span> {{totalBookings}}</span>
    </div>
  </div>

  <input class="search-input" type="search" placeholder="Sök på reg.nr eller bokningsnr." [formControl]="searchInput"
    data-test="search-all-bookings" spellcheck="false" autocomplete="off" />

    <mat-radio-group class="filters" [formControl]="serviceTypeFilter">
      <mat-label>
        <h5>Filter:</h5>
      </mat-label>
      <mat-radio-button color="primary" value="{{undefined}}" checked>Alla</mat-radio-button>
      <mat-radio-button color="primary" value="CAR_WASH">Tvätt</mat-radio-button>
      @if (isGarage()) {
        <mat-radio-button color="primary" value="GARAGE">Laddning</mat-radio-button>
      }
      <mat-radio-button color="primary" value="WORKSHOP">Verkstad</mat-radio-button>
    </mat-radio-group>

    <mat-paginator [length]="totalBookings" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" aria-label="Välj sida"
      (page)="paginator($event)">
    </mat-paginator>

    @if (showSpinner) {
      <div class="spinner-table-wrapper">
        <mat-spinner diameter="70"></mat-spinner>
      </div>
    }

    @if (!showSpinner) {
      <app-bookings-table [bookings]="bookings" topic="parked" [sortOrder]="sortOrder"
        [showParkTimeColumn]="true">
      </app-bookings-table>
    }

    @if (bookings.length <= 0 && searchInput.value) {
      <div class="empty-content">
        <p>Kan inte hitta någon bokning@if (searchInput.value) {
          <span> som matchar "{{searchInput.value}}"</span>
        }.</p>
      </div>
    }

    @if (bookings.length <= 0 && !searchInput.value) {
      <div class="empty-content">
        <p>Kunde inte hitta några bokningar.</p>
      </div>
    }

    <mat-paginator [length]="totalBookings" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" aria-label="Välj sida"
      (page)="paginator($event)">
    </mat-paginator>
  </div>